import * as i0 from '@angular/core';
import * as i1 from './safe-html.module';
import * as i2 from './safe-html.pipe';
export const EscapeHtmlPipeModuleNgFactory:i0.NgModuleFactory<i1.EscapeHtmlPipeModule> = (null as any);
var _decl0_1:i2.EscapeHtmlPipe = (<any>(null as any));
var _decl0_2:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_3:i0.ElementRef<any> = (<any>(null as any));
